import { jsx as c } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import y from "@mui/material/LinearProgress";
import p from "styled-components";
import { hexToRgba as i, getFlavorColor as a } from "../../theme/utils/styleUtils.js";
const f = {
  root: "linearProgressRoot",
  colorPrimary: "linearProgressColorPrimary",
  colorSecondary: "linearProgressColorSecondary",
  dashedColorPrimary: "linearProgressDashedColorPrimary",
  dashedColorSecondary: "linearProgressDashedColorSecondary",
  barColorPrimary: "linearProgressBarColorPrimary",
  barColorSecondary: "linearProgressBarColorSecondary"
}, e = {
  small: "small",
  medium: "medium",
  large: "large"
}, n = (r) => {
  let o = "4px";
  return r === e.medium ? o = "8px" : r === e.large && (o = "16px"), o;
}, l = (r) => {
  let o = "1px";
  return r === e.medium ? o = "2px" : r === e.large && (o = "4px"), o;
}, C = (r) => {
  let o = "10px 10px";
  return r === e.medium ? o = "11px 11px" : r === e.large && (o = "12px 12px"), o;
}, b = p(y).withConfig({
  displayName: "StyledLinearProgress"
})([
  "&&.linearProgressRoot{height:",
  ";background-color:",
  ";border-radius:",
  ";}&& .linearProgressColorPrimary,&& .linearProgressColorSecondary{background-color:",
  ";}&& .linearProgressColorPrimary::after,&& .linearProgressColorSecondary::after{content:'';width:100%;height:",
  ";position:absolute;background-color:",
  ";border-radius:",
  ";}&& .linearProgressBarColorPrimary,&& .linearProgressBarColorSecondary{background-color:",
  ";border-radius:",
  ";}&& .linearProgressDashedColorPrimary,&& .linearProgressDashedColorSecondary{background-image:",
  ";background-size:",
  ";}"
], ({ $size: r }) => n(r), ({ theme: r, $flavor: o, variant: s }) => s === "buffer" ? "transparent" : i(a(r, o), 0.15), ({ $size: r }) => l(r), ({ theme: r }) => r.colors.white, ({ $size: r }) => n(r), ({ theme: r, $flavor: o }) => i(a(r, o), 0.5), ({ $size: r }) => l(r), ({ theme: r, $flavor: o }) => a(r, o), ({ $size: r }) => l(r), ({ theme: r, $flavor: o }) => `radial-gradient(
      ${i(a(r, o), 0.5)},
      transparent 45%
    )`, ({ $size: r }) => C(r)), x = /* @__PURE__ */ u(({ classes: r, flavor: o = "normal", value: s = 0, valueBuffer: t = 0, variant: d = "indeterminate", size: g = "small", ...m }, P) => /* @__PURE__ */ c(b, {
  "aria-label": "actions in progress",
  ...m,
  ref: P,
  classes: {
    ...f,
    ...r
  },
  $flavor: o,
  $size: g,
  value: s,
  valueBuffer: t,
  variant: d
}));
x.displayName = "LinearProgress";
export {
  x as default,
  e as sizes
};
